<template >
  <div style="padding: 10px;height: 95%">
    <el-form :model="formData" label-width="120px">
      <el-row style="text-align: center;">
        <el-col :span="22">
          <el-form-item label="模板名称：" required>
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：">
            <el-input v-model="formData.remark" type="textarea"
                      :autosize="{ minRows: 1, maxRows: 10}"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="config-section" >
      <el-row>
        <el-col :span="14">
          <el-row class="box">
            <el-col :span="2">
              <el-button type="warning" @click="addStageRow(1)"
                         style="font-size: 20px;top: 2px;">+
              </el-button>
            </el-col>
            <el-col :span="16" style="font-size: 20px;text-align: center">项目阶段名称</el-col>
          </el-row>

          <div style="overflow-x: hidden;overflow-y: auto;">
            <!-- 递归渲染阶段列表 -->
            <StageNode
                v-for="(stage, index) in formData.stage_list"
                :key="stage.nanoid"
                :stage="stage"
                :currentIndex="index + 1"
                @add-child="handleAddChild"
                @remove="handleRemoveStage"
            />
          </div>
        </el-col>

        <el-col :span="9" :offset="1">
          <el-row class="box">
            <el-col :span="20" style="text-align: center;font-size: 20px;">文档目录名称</el-col>
            <el-col :span="4" style="text-align: center">
              <el-button type="warning" @click="addDocumentDirectoryRow(1)"
                         style="font-size: 20px;top: 2px;">+
              </el-button>
            </el-col>
          </el-row>
          <div style="overflow-x: hidden;overflow-y: auto;">
            <el-row v-for="item in formData.document_directory_list" :key="item.nanoid" style="margin-top:10px; margin-bottom: 10px;" gutter="5">
              <el-col :span="20">
                <el-input v-model="item.name" placeholder="文档目录名称"></el-input>
              </el-col>
              <el-col :span="4" >
                <div class="close" @click="removeDocumentDirectoryRow(item.nanoid)"
                     v-if="formData.document_directory_list.length > 1" >
                  <el-icon>
                    <ElIconClose></ElIconClose>
                  </el-icon>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row style="justify-content: center;width: 100%;margin-top: 40px">
        <el-button type="primary"  @click="saveProjectTemplate()">
          保存
        </el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { nanoid } from "nanoid";
import StageNode from './StageNode.vue';

export default {
  name: "EditProjectTemplate",
  inject: ['$fn'],
  components: {StageNode},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      formData: {
        name: "",
        remark: "",
        stage_list: [], // 项目阶段列表
        document_directory_list: [], // 文档目录列表
      },
    }
  },

  created() {
    this.getProjectTemplateInfo();
  },

  methods: {

    //获取项目模板信息
    async getProjectTemplateInfo() {
      this.formData = await this.$http('prjTemplateService.getTemplateData', this.parentData);
    },

    // 保存模板
    async saveProjectTemplate() {
      if (!this.formData.name) {
        this.$message.error('模板名称不能为空');
        return;
      }
      if (!this.formData.stage_list) {
        this.$message.error('项目阶段不能为空');
        return;
      }
      if (!this.formData.document_directory_list) {
        this.$message.error('文档目录不能为空');
        return;
      }
      await this.$http('prjTemplateService.editTemplate', this.formData);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },

    // 添加项目阶段
    addStageRow(cnt) {
      for (let i = 0; i < cnt; i++) {
        this.formData.stage_list.push({
          nanoid: nanoid(),
          name: "",
          children: [], // 子阶段
        });
      }
    },

    // 删除项目阶段
    removeStageRow(nanoid) {
      const removeNode = (stages) => {
        return stages.filter(stage => {
          if (stage.nanoid === nanoid) return false;
          if (stage.children?.length) {
            stage.children = removeNode(stage.children);
          }
          return true;
        });
      };

      this.formData.stage_list = removeNode(this.formData.stage_list);
    },

    // 添加子阶段
    handleAddChild(parentNanoid) {
      const findParent = (stages) => {
        for (const stage of stages) {
          if (stage.nanoid === parentNanoid) {
            return stage;
          }
          if (stage.children?.length) {
            const found = findParent(stage.children);
            if (found) return found;
          }
        }
      };

      const parentStage = findParent(this.formData.stage_list);
      if (parentStage) {
        parentStage.children.push({
          nanoid: nanoid(),
          name: "",
          children: [],
        });
      }
    },

    //添加文档目录行
    addDocumentDirectoryRow(cnt) {
      for (var i = 0; i < cnt; i++) {
        this.formData.document_directory_list.push({
          nanoid: nanoid(),
        })
      }
    },

    //删除文档目录行
    removeDocumentDirectoryRow(nanoid) {
      let index = this.formData.document_directory_list.findIndex(item => item.nanoid === nanoid);
      this.formData.document_directory_list.splice(index, 1);
    },

    // 删除项目阶段（递归）
    handleRemoveStage(targetNanoid) {
      this.removeStageRow(targetNanoid);
    },
  }
}
</script>

<style scoped>
/* 修改父组件样式 */
.config-section {
  height: 75%;
  background: #f8f9fa;
  padding: 15px 15px 0 15px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
}

.box {
  background-color: #f1f3f5;
  border-radius: 4px;
}

/* 优化阶段节点样式 */
.stage-node {
  position: relative;
  margin: 12px 0;
  transition: all 0.3s;
}

.stage-node:hover {
  background: #f8f9fa;
  border-radius: 4px;
}

.stage-node:before {
  content: '';
  position: absolute;
  left: -25px;
  top: 24px;
  height: calc(100% - 48px);
  width: 2px;
  background: #4dabf7;
  border-radius: 2px;
}

/* 按钮样式调整 */
.close {
  font-size: 15px;
  text-align: center;
}


</style>